<template>
  <div
    v-if="isVisible"
    class="fixed inset-0 z-50 flex items-center justify-center"
  >
    <!-- Overlay -->
    <div class="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>

    <!-- Modal -->
    <div class="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
      <!-- Icon -->
      <div class="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full">
        <svg class="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.996-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
      </div>

      <!-- Title -->
      <h3 class="text-xl font-semibold text-gray-900 text-center mb-2">
        Permission Required
      </h3>

      <!-- Message -->
      <p class="text-gray-600 text-center mb-6">
        {{ message || 'You don\'t have permission to access this resource. Please contact your administrator or try accessing from the dashboard.' }}
      </p>

      <!-- Actions -->
      <div class="flex flex-col gap-3">
        <!-- Primary CTA -->
        <button
          @click="goToDashboard"
          class="w-full bg-purple-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-purple-700 transition-colors focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

interface Props {
  isVisible?: boolean
  message?: string
}

const props = withDefaults(defineProps<Props>(), {
  isVisible: false,
  message: ''
})

const emit = defineEmits<{
  close: []
  dashboardRedirect: []
}>()

const router = useRouter()

const goToDashboard = () => {
  emit('dashboardRedirect')
  router.push('/dashboard')
}
</script>
